
import { supabase } from "@/integrations/supabase/client";
import { ReadingFormValues } from "./types";

export const readingService = {
  async uploadImage(file: File): Promise<string> {
    const fileExt = file.name.split('.').pop();
    const filePath = `${crypto.randomUUID()}.${fileExt}`;

    const { error: uploadError } = await supabase.storage
      .from('readings')
      .upload(filePath, file);

    if (uploadError) throw uploadError;

    const { data: { publicUrl } } = supabase.storage
      .from('readings')
      .getPublicUrl(filePath);

    return publicUrl;
  },

  async createReading(data: ReadingFormValues, photoUrl: string | null) {
    const { error } = await supabase
      .from('readings')
      .insert({
        house_id: data.house,
        type: data.type,
        reading_value: data.reading,
        reading_date: new Date(data.month + '-01').toISOString(),
        photo_url: photoUrl,
      });

    if (error) throw error;
  },

  async fetchHouses() {
    const { data, error } = await supabase
      .from('houses')
      .select('id, name');
    
    if (error) throw error;
    return data;
  }
};
